import type { BaseState } from '@kc-console/context';
import type { Guard } from '../../../types';

/**
 * Account 에서 서버사이드 초기 진입 시 호출되어야하는 예시 가드
 * @description
 * 실제 개발 시, 필요한 가드를 정의해서 사용
 */
export const accountInitialGuard: Guard<BaseState> = async ({ state }) => {
  const { status } = state;
  return { status };
};

accountInitialGuard.displayName = 'accountInitialGuard';
